import { useQuery } from "@tanstack/react-query";
import { PaymentService } from "../services/PaymentService";
export function usePaymentMethodsQuery(enabled = true) {
    return useQuery({
        queryKey: ["medos", "payment-methods"],
        queryFn: () => PaymentService.fetchPaymentMethods(),
        enabled,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
}
